import styled from 'styled-components';

type BackdropProps = {
  opacity: number;
};

export const BackDrop = styled.div<BackdropProps>`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  background-color: rgba(55, 71, 79, ${props => props.opacity});
  transition: background-color 0.2s;
  height: 100%;
  text-align: center;
  z-index: 9999999;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

type ModalProps = {
  xPosition: number;
};

export const Modal = styled.div<ModalProps>`
  position: relative;
  display: inline-block;
  width: 50%;
  min-width: 720px;
  height: 100%;
  padding: 0;
  overflow: hidden;
  z-index: 999999;
  background-color: #fff;
  text-align: left;
  box-sizing: border-box;
  right: ${props => `${props.xPosition}px`};
  transition: right 0.2s;
`;
